import type { IDeadish, IEntity } from '../../../entities/entitiesUtils'
import { entitiesUtils } from '../../../entities/entitiesUtils-sidecar'
import { l } from '../../../lib/imports'
import { createId } from '../../../main/common'
import { golfPhysics } from '../physics/golfPhysics-sidecar'
import { golfPhysicsDefs } from '../physics/golfPhysicsDefs-sidecar'

export interface IGolfPuck extends IEntity, IDeadish {
  body: planck.Body
}

const _objs: IGolfPuck[] = []
export function getAll() {
  return _objs
}

export function findById(id: number) {
  return entitiesUtils.findById(id, _objs)
}

export function findByIdSafe(id: number) {
  return entitiesUtils.findByIdSafe(id, _objs)
}

export function create(x: number, y: number): IGolfPuck {
  let id = createId()

  let body = golfPhysics.createBodyCircle(
    x,
    y,
    20,
    golfPhysicsDefs.puckPhysicsDef,
  )

  let obj: IGolfPuck = {
    id,
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    body,
  }
  _objs.push(obj)
  return obj
}

export function moveToXY(obj: IGolfPuck, x: number, y: number) {}

export function kill(obj: IGolfPuck) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(_objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(_objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(_objs, (c) => {
    // TODO: remove physics
  })
}
function update(obj: IGolfPuck) {}
